import React from "react";
import {
  XCircleIcon,
  CheckCircleIcon,
  ArrowUpTrayIcon
} from "@heroicons/react/24/outline";

const UploadStatus = ({
  uploadError,
  uploadSuccess,
  uploadMessage,
  isUploading,
  uploadProgress,
  setUploadError
}) => {
  if (uploadError) {
    return (
      <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
        <div className="flex items-center text-red-700">
          <XCircleIcon className="h-5 w-5 mr-2 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-medium">Upload Failed</p>
            <p className="text-sm mt-1">{uploadError}</p>
            <button
              onClick={() => setUploadError(null)}
              className="mt-2 text-xs text-red-600 hover:text-red-800 underline"
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  if (uploadSuccess) {
    return (
      <div className="mt-2 p-3 bg-green-50 border border-green-200 rounded-md">
        <div className="flex items-center text-green-700">
          <CheckCircleIcon className="h-5 w-5 mr-2 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-medium">✓ Upload Successful!</p>
            <p className="text-sm mt-1">{uploadMessage}</p>
            <div className="mt-2 flex items-center">
              <div className="h-2 w-2 rounded-full bg-green-500 mr-2 animate-pulse"></div>
              <span className="text-xs text-green-600">
                Table updated with new data
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  if (isUploading) {
    return (
      <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-md">
        <div className="flex items-center text-blue-700">
          <ArrowUpTrayIcon className="h-5 w-5 mr-2 flex-shrink-0 animate-pulse" />
          <div className="flex-1">
            <div className="flex justify-between items-center mb-1">
              <p className="font-medium">Uploading Excel File</p>
              <p className="text-sm font-medium">{uploadProgress}%</p>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
            <p className="text-xs mt-2 text-blue-600">
              {uploadProgress < 50 ? 'Uploading file...' : 
               uploadProgress < 90 ? 'Processing...' : 
               'Finishing up...'}
            </p>
          </div>
        </div>
      </div>
    );
  }
  
  return null;
};

export default UploadStatus;